/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UserAnswerPrograms,
    UserAnswerProgramsFromJSON,
    UserAnswerProgramsFromJSONTyped,
    UserAnswerProgramsToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserAnswer
 */
export interface UserAnswer {
    /**
     * 
     * @type {string}
     * @memberof UserAnswer
     */
    userAuthId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAnswer
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAnswer
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAnswer
     */
    dob?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAnswer
     */
    sex?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAnswer
     */
    zipCode?: string;
    /**
     * 
     * @type {Array<UserAnswerPrograms>}
     * @memberof UserAnswer
     */
    programs?: Array<UserAnswerPrograms>;
}

export function UserAnswerFromJSON(json: any): UserAnswer {
    return UserAnswerFromJSONTyped(json, false);
}

export function UserAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAnswer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userAuthId': !exists(json, 'user-auth-id') ? undefined : json['user-auth-id'],
        'firstName': !exists(json, 'first-name') ? undefined : json['first-name'],
        'lastName': !exists(json, 'last-name') ? undefined : json['last-name'],
        'dob': !exists(json, 'dob') ? undefined : json['dob'],
        'sex': !exists(json, 'sex') ? undefined : json['sex'],
        'zipCode': !exists(json, 'zip-code') ? undefined : json['zip-code'],
        'programs': !exists(json, 'programs') ? undefined : ((json['programs'] as Array<any>).map(UserAnswerProgramsFromJSON)),
    };
}

export function UserAnswerToJSON(value?: UserAnswer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user-auth-id': value.userAuthId,
        'first-name': value.firstName,
        'last-name': value.lastName,
        'dob': value.dob,
        'sex': value.sex,
        'zip-code': value.zipCode,
        'programs': value.programs === undefined ? undefined : ((value.programs as Array<any>).map(UserAnswerProgramsToJSON)),
    };
}


